export default __webpack_public_path__ + "static/media/Tournee_du_chat_noir_Theophile_Alexandre_Steinlen.61471e70.jpg";